export default [
    {
        path: '/suicideprevention/certificate',
        name: 'suicideprevention.certificate',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Certificate.vue'),
            header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/document/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "mha.sps" */ '@/views/public/footer/index.vue'),
        }
    },
    {
        path: '/summit/invoice',
        name: 'summit.invoice',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Invoice.vue'),
            header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/document/components/TheHeader.vue'),
            footer: () => import(/* webpackChunkName: "mha.sps" */ '@/views/public/footer/index.vue'),
        }
    },
    {
        path: '/suicideprevention/confirmation',
        // redirect: '/',
        name: 'summit.confirmation',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Confirmation.vue'),
            // header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/components/TheHeader.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/suicideprevention',
        // redirect: '/',
        name: 'summit.index',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Index.vue'),
            // header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/components/TheHeader.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        meta: {
            registrationSource: 'General'
        }
    },
    {
        path: '/suicideprevention/upgrade',
        name: 'summit.upgrade',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Upgrade.vue'),
            footer: () => import(/* webpackChunkName: "mha.sps" */ '@/views/public/footer/index.vue'),
        }
    },

    {
        path: '/suicideprevention/upgrade/confirmation',
        name: 'summit.upgrade.confirmation',
        components: {
            default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/components/UpgradeConfirmation.vue'),
            footer: () => import(/* webpackChunkName: "mha.sps" */ '@/views/public/footer/index.vue'),
        }
    },
    {
        path: '/suicideprevention/alliance/confirmation',
        redirect: '/',
        // name: 'summit.alliance.donation',
        // components: {
        //    default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Donation.vue'),
        //    header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/components/TheHeader.vue'),
        //    footer: () => import('../views/public/footer/index.vue')
        // }
    },
    {
        path: '/suicideprevention/alliance',
        redirect: '/',
        // name: 'summit.alliance.index',
        // components: {
        //     default: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/views/Index.vue'),
        //     header: () => import(/* webpackChunkName: "mha.sps" */ '@/modules/events/suicidePreventionSummit/components/TheHeader.vue'),
        //     footer: () => import('../views/public/footer/index.vue')
        // },
        // meta: {
        //     registrationSource: 'Alliance'
        // }
    },
    {
        path: '/events/:type/:document',
        name: 'event.document',
        components: {
            default: () => import(/* webpackChunkName: "mha.event" */ '@/modules/events/document/components/Index.vue'),
            header: () => import(/* webpackChunkName: "mha.event" */ '@/modules/events/document/components/TheHeader.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    // {
    //     path: '/live/disasters/:access',
    //     name: 'training',
    //     props: {
    //         default: true
    //     },
    //     components: {
    //         default: () => import(/* webpackChunkName: "training" */ '@/modules/training/views/DisasterMentalHealthCounselling.vue')
    //     }
    // },
    // {
    //     path: '/live/:document',
    //     name: 'training.invoice',
    //     props: {
    //         default: true
    //     },
    //     components: {
    //         default: () => import(/* webpackChunkName: "event.document" */ '@/modules/training/views/Download.vue'),
    //         header: () => import(/* webpackChunkName: "event.document" */ '@/modules/events/document/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "event.document" */ '@/modules/events/document/components/TheFooter.vue'),
    //     }
    // }

    {
        path: '/summit',
        name: 'mhss.index',
        components: {
            default: () => import('@/modules/events/mhss/views/Index.vue'),
            footer: () => import('@/modules/events/mhss/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/upgrade',
        name: 'mhss.upgrade',
        components: {
            default: () => import('@/modules/events/mhss/views/Upgrade.vue'),
            footer: () => import('@/modules/events/mhss/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/upgrade/confirmation',
        name: 'mhss.upgradeConfirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/UpgradeConfirmation.vue'),
            footer: () => import('@/modules/events/mhss/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/confirmation',
        name: 'mhss.confirmation',
        components: {
            default: () => import('@/modules/events/mhss/components/Confirmation.vue'),
            footer: () => import('@/modules/events/mhss/components/TheFooter.vue')
        }
    },

// EBCC
    {
        path: '/summit/ebcc',
        name: 'mhss.ebcc.index',
        components: {
            default: () => import('@/modules/events/ebcc/views/Index.vue'),
            footer: () => import('@/modules/events/ebcc/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/ebcc/upgrade',
        name: 'mhss.ebcc.upgrade',
        components: {
            default: () => import('@/modules/events/ebcc/views/Upgrade.vue'),
            footer: () => import('@/modules/events/ebcc/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/ebcc/upgrade/confirmation',
        name: 'mhss.ebcc.upgradeConfirmation',
        components: {
            default: () => import('@/modules/events/ebcc/components/UpgradeConfirmation.vue'),
            footer: () => import('@/modules/events/ebcc/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/ebcc/confirmation',
        name: 'mhss.ebcc.confirmation',
        components: {
            default: () => import('@/modules/events/ebcc/components/Confirmation.vue'),
            footer: () => import('@/modules/events/ebcc/components/TheFooter.vue')
        }
    },

// IACP
    {
        path: '/summit/iacp',
        name: 'mhss.iacp.index',
        components: {
            default: () => import('@/modules/events/iacp/views/Index.vue'),
            footer: () => import('@/modules/events/iacp/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/iacp/upgrade',
        name: 'mhss.iacp.upgrade',
        components: {
            default: () => import('@/modules/events/iacp/views/Upgrade.vue'),
            footer: () => import('@/modules/events/iacp/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/iacp/upgrade/confirmation',
        name: 'mhss.iacp.upgradeConfirmation',
        components: {
            default: () => import('@/modules/events/iacp/components/UpgradeConfirmation.vue'),
            footer: () => import('@/modules/events/iacp/components/TheFooter.vue')
        }
    },
    {
        path: '/summit/iacp/confirmation',
        name: 'mhss.iacp.confirmation',
        components: {
            default: () => import('@/modules/events/iacp/components/Confirmation.vue'),
            footer: () => import('@/modules/events/iacp/components/TheFooter.vue')
        }
    },
    // EAP
    // {
    //     path: '/summit/eap',
    //     name: 'mhss.eap.index',
    //     components: {
    //         default: () => import('@/modules/events/eap/views/Index.vue'),
    //         footer: () => import('@/modules/events/eap/components/TheFooter.vue')
    //     }
    // },
    // {
    //     path: '/summit/eap/upgrade',
    //     name: 'mhss.eap.upgrade',
    //     components: {
    //         default: () => import('@/modules/events/eap/views/Upgrade.vue'),
    //         footer: () => import('@/modules/events/eap/components/TheFooter.vue')
    //     }
    // },
    // {
    //     path: '/summit/eap/upgrade/confirmation',
    //     name: 'mhss.eap.upgradeConfirmation',
    //     components: {
    //         default: () => import('@/modules/events/eap/components/UpgradeConfirmation.vue'),
    //         footer: () => import('@/modules/events/eap/components/TheFooter.vue')
    //     }
    // },
    // {
    //     path: '/summit/eap/confirmation',
    //     name: 'mhss.eap.confirmation',
    //     components: {
    //         default: () => import('@/modules/events/eap/components/Confirmation.vue'),
    //         footer: () => import('@/modules/events/eap/components/TheFooter.vue')
    //     }
    // },
]
